import styled from 'styled-components';
import Modal from '../Modal';

export const StyledModal = styled(Modal)`
  &__content {
    box-sizing: border-box;
    width: 670px;
    outline: none;
    border-radius: 4px;
  }
`;

export const ModalFooter = styled.div`
  padding: 24px 32px;
  text-align: right;

  > * {
    min-width: 160px;
  }

  > * + * {
    margin-left: 16px;
  }
`;

export const ModalBody = styled.div`
  padding: 60px 60px 16px;
  color: #444444;
`;

export const Title = styled.div`
  font-size: 24px;
  margin-bottom: 8px;
  font-weight: 600;
`;

export const Message = styled.div`
  line-height: 24px;
`;
